import { render, staticRenderFns } from "./requestMethod.vue?vue&type=template&id=1d2f37f1&"
import script from "./requestMethod.vue?vue&type=script&lang=js&"
export * from "./requestMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports